import { Button } from "antd";
import { NativeButtonProps } from "antd/lib/button/button";
import './theme.less'
import React from "react";

export class SaveButton extends React.Component<NativeButtonProps> {
  render() {
    return <Button className="customSaveBtn" {...this.props}>{this.props.children}</Button>
  }
}